import React from "react";
import { Facebook, Instagram, Youtube, ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#0e4a7a] to-[#082c4a] text-white">
      <div className="max-w-6xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-14 h-14 rounded-xl bg-white/95 flex items-center justify-center p-1 shadow-md">
              <img
                src="https://customer-assets.emergentagent.com/job_numero-builder/artifacts/yhm96yb7_VANDIERE.png"
                alt="Números Fácil"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="font-extrabold text-lg">Números Fácil</span>
          </div>
          <p className="text-sm text-blue-100/80 max-w-md">
            Tu portal diario de números fuertes y calientes para la Lotería Dominicana. Predicciones basadas en estadísticas y numerología.
          </p>
        </div>

        <div>
          <h4 className="font-bold mb-3 text-yellow-300">Enlaces</h4>
          <ul className="space-y-2 text-sm text-blue-100/90">
            <li><a href="/#numeros-del-dia" className="hover:text-white">Números del Día</a></li>
            <li><a href="/tabla-jaladora" className="hover:text-white">Tabla Jaladora</a></li>
            <li><a href="/numerologia#horoscopo" className="hover:text-white">Horóscopo</a></li>
            <li><a href="/suenos" className="hover:text-white">Sueños</a></li>
            <li><a href="/horas-espejo" className="hover:text-white">Horas Espejo</a></li>
            <li><a href="/interpretar" className="hover:text-white">Interpretar Números</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold mb-3 text-yellow-300">Redes Sociales</h4>
          <div className="flex gap-3">
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-blue-500 flex items-center justify-center transition" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-pink-500 flex items-center justify-center transition" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-red-500 flex items-center justify-center transition" aria-label="Youtube">
              <Youtube className="w-4 h-4" />
            </a>
          </div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 text-sm transition"
          >
            <ArrowUp className="w-4 h-4" /> Subir
          </button>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-blue-100/70">
          <p>© {new Date().getFullYear()} Números Fácil. Todos los derechos reservados.</p>
          <p>Juega con responsabilidad · +18</p>
        </div>
      </div>
    </footer>
  );
}
